export default "__VITE_ASSET__BdeQTLJF__"